import { React } from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Button, Space } from 'antd';
import './ErrorScreen.css';
import AvaLAN_Logo from '../../../src/assets/AvaLAN_Logo.png';

const { Title, Text, } = Typography;

export const ErrorScreen = ({...props}) => {

    let defaultErrorObj = {
        title: 'Oops! Something went wrong', 
        message: "We couldn't load the page. Please try again later.", 
    }

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const errorCode = queryParams.get('code');

    window.onload = () => {
        sessionStorage.removeItem('showDisplayError');
    }

    const renderErrorMessage = () => {
        switch (errorCode){
            case 'maxconnections': 
                return {
                    title: "We've closed this connection", 
                    message: "It looks like you have more than one window or tab open in your browser. To ensure the best experience and prevent any data conflicts, please close all other sessions before continuing."
                }
            case 'timeout': 
                return {
                    title: "Your session has expired",
                    message: "Your session has ended due to inactivity. For your security, we've logged you out to protect your information.",
                    button: <Button type='primary' onClick={() =>  window.location.href = '/'}>
                                Back to login
                            </Button>
                }
            case '404':
                return {
                    title: "404 Page Not Found",
                    message: "The page you are looking for was not found.",
                    button: <Button type='primary' onClick={() =>  window.location.href = '/'}>
                                Back to login
                            </Button>
                }
            default:
                return defaultErrorObj;
            }
    }

    const { title, message, button } = renderErrorMessage();

    return (
        <>
            <div className='error-screen'>
                <div className='error-screen--container'>
                    <Space size='middle' direction='vertical' style={{width:'100%'}}>
                        <a href="/" onClick={() => window.location.reload()}><img src="/img/logoL" alt="AvaLAN Networks logo" style={{pointerEvents: 'none', width: 100, height: 'auto', }}/></a>
                        <Title className='error-screen--title'>{title}</Title>
                        <Text>{message}</Text>
                        {button && button }
                        {props.resetErrorBoundary && (
                            <div>
                                <Button type='primary' onClick={props.resetErrorBoundary}>
                                    Reload now
                                </Button>
                            </div>
                        )}
                    </Space>
                </div>
            </div>
        </>
    );
}